import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberFormatPipe'
})
export class PhoneNumberFormatPipe implements PipeTransform {

  transform(phoneNumber: any, format: any): any {
    let newPhoneNumber = '';
    if (angular.isDefined(phoneNumber) && (phoneNumber !== null)) {
      newPhoneNumber = phoneNumber.replace(/ |-/gi, "");
    }
    let specialChars = ["+", "-", " "];
    let newNumber = "";
    let count = 0;
    let i;
    for (i = 0; i < format.length; i++) {
      if (specialChars.indexOf(format[i]) > -1) {
        if (format[i] == newPhoneNumber[i]) {
          newNumber = newNumber + format[i];
          count++;
        } else {
          newNumber = newNumber + format[i];
        }
      } else {
        if (newPhoneNumber[count]) {
          newNumber = newNumber + newPhoneNumber[count];
        }
        count++;
      }
    }
    if (i == format.length) {
      return newNumber;
    }
  }

}
